export const LOCALES = [
  { code: 'en', label: 'English', comment: "device's language" },
  { code: 'fr', label: 'Français', en: 'French', comment: 'preferred' }
];
